import styled from '@emotion/styled';
import { Blanket } from '@kc-console/common-ui';

import { GNB_HEIGHT } from '../../../constants/layout';
import { GNB_TOB_BAR_HEIGHT } from '../GnbTopBar';

interface MegaMenuContainerProps {
  hasRegion: boolean;
  isOpen: boolean;
}

export const MegaMenuContainer = styled.div<MegaMenuContainerProps>(
  ({ isOpen, theme, hasRegion }) => ({
    display: isOpen ? 'flex' : 'none',
    flexDirection: 'column',
    width: hasRegion ? 1300 : 480,
    maxWidth: '100vw',
    backgroundColor: 'white',
    top: `calc(${GNB_HEIGHT}px + ${GNB_TOB_BAR_HEIGHT}px)`,
    height: `calc(100vh - ${GNB_HEIGHT}px - ${GNB_TOB_BAR_HEIGHT}px)`,
    minHeight: `calc(100vh - ${GNB_HEIGHT}px - ${GNB_TOB_BAR_HEIGHT}px)`,
    position: 'absolute',
    zIndex: theme.zIndex.navigationOverlay,
    margin: 0,
    padding: 32,
    boxShadow: theme.elevation.level_3,
  }),
);

export const MegaMenuBodyContainer = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  gap: 8px;
`;

export const MegaMenuBackdrop = styled(Blanket)`
  position: fixed;
  top: 88px;
  left: 0;
  width: 100%;
  height: calc(100vh - ${GNB_HEIGHT}px - ${GNB_TOB_BAR_HEIGHT}px);
  z-index: ${({ theme }) => theme.zIndex.navigationOverlay};
`;
